import {
  createSlice,
  createSelector,
  PayloadAction,
  createAsyncThunk,
} from "@reduxjs/toolkit";

import {
  resetSnack,
  successSnack,
  errorSnack,
} from "../snackbar/snackbarSlice";
// import { fetchOrderUserByID } from "../users/usersSlice";

import axios from "axios";

const baseURL = process.env.REACT_APP_API_URL;

export const fetchPurchaseOrders = createAsyncThunk(
  "purchaseOrders/fetchPurchaseOrders",
  async (args, thunkAPI) => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${args.token}` },
      };
      const response = await axios.get(
        `${baseURL}/v1/admin/purchase_orders?${args.query}`,
        config
      );
      return await response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description ||
              "Error fetching PurchaseOrders list"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const fetchPurchaseOrderByID = createAsyncThunk(
  "purchaseOrders/fetchPurchaseOrderByID",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      const response = await axios.get(
        `${baseURL}/v1/admin/purchase_orders/${args.purchaseOrderID}`,
        config
      );
      return await response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description ||
              "Error fetching purchase order data"
          )
        );
      }

      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const fetchOrderProductsPurchaseOrders = createAsyncThunk(
  "purchaseOrders/fetchOrderProductsPurchaseOrders",
  async (args, thunkAPI) => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${args.token}` },
      };
      const response = await axios.get(
        `${baseURL}/v1/admin/order_products${args.query}`,
        config
      );
      thunkAPI.dispatch(setLastQuery(args.query));
      thunkAPI.dispatch(
        setPurchaseOrdersAmount(response.headers["x-total-count"])
      );
      return await response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description ||
              "Error fetching PurchaseOrders list"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const fetchMoreOrderProductsPurchaseOrders = createAsyncThunk(
  "purchaseOrders/fetchMoreOrderProductsPurchaseOrders",
  async (args, thunkAPI) => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${args.token}` },
      };
      const response = await axios.get(
        `${baseURL}/v1/admin/order_products${args.query}&offset=${args.offset}`,
        config
      );

      // thunkAPI.dispatch(setLastQuery(args.query));
      thunkAPI.dispatch(
        setPurchaseOrdersAmount(response.headers["x-total-count"])
      );

      return await response.data;
    } catch (error) {
      if (error.message.includes("401")) {
        localStorage.removeItem("coreUser");
        localStorage.removeItem("coreToken");
      }
      if (error.response && error.response.data) {
        // thunkAPI.dispatch(
        //   errorSnack(
        //     error.response.data.error_description ||
        //       'Error fetching products list'
        //   )
        // );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const getFullList = createAsyncThunk(
  "products/getFullList",
  async (args, thunkAPI) => {
    let objToMap = [];
    for (let i = 0; i < (args.targetLength - args.offset) / 25; i++) {
      objToMap.push({
        token: args.token,
        query: args.query,
        offset: args.offset + 25 * i,
      });
    }

    for (const requestData of objToMap) {
      await thunkAPI.dispatch(
        fetchMoreOrderProductsPurchaseOrders(requestData)
      );
      await new Promise((r) => setTimeout(r, 30000));
    }
  }
);

const purchaseOrdersSlice = createSlice({
  name: "purchaseOrders",
  initialState: {
    purchaseOrder: {},
    purchaseOrdersList: [],
    orderProductsList: [],
    loading: "idle",
    message: "",
    error: "",
    viewing: false,
    purchaseOrdersAmount: "",
    lastQuery: "",
  },
  reducers: {
    setPurchaseOrder(state, action) {
      state.purchaseOrder = action.payload;
    },
    setViewing(state, action) {
      state.viewing = action.payload;
    },
    setLastQuery: (state, action) => {
      state.lastQuery = action.payload;
    },
    setPurchaseOrdersAmount: (state, action) => {
      state.purchaseOrdersAmount = action.payload;
    },
    resetOrderProducts: (state, action) => {
      state.orderProductsList = [];
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchPurchaseOrders.pending, (state) => {
      state.purchaseOrdersList = [];
      state.loading = "loading";
    });
    builder.addCase(fetchPurchaseOrders.fulfilled, (state, { payload }) => {
      state.purchaseOrdersList = payload;
      state.loading = "loaded";
    });
    builder.addCase(fetchPurchaseOrders.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(fetchOrderProductsPurchaseOrders.pending, (state) => {
      state.orderProductsList = [];
      state.loading = "loading";
    });
    builder.addCase(
      fetchMoreOrderProductsPurchaseOrders.fulfilled,
      (state, { payload }) => {
        state.error = "";
        state.orderProductsList = state.orderProductsList.concat(payload);
        state.loading = "loaded";
      }
    );
    builder.addCase(
      fetchMoreOrderProductsPurchaseOrders.rejected,
      (state, action) => {
        state.loading = "error";
        state.error = action.error.message;
      }
    );
    builder.addCase(getFullList.fulfilled, (state, { payload }) => {
      state.error = "";
      state.orderProductsList = state.orderProductsList.sort(function (a, b) {
        return a.id - b.id;
      });
      state.loading = "loaded";
    });
    builder.addCase(getFullList.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(
      fetchOrderProductsPurchaseOrders.fulfilled,
      (state, { payload }) => {
        state.orderProductsList = payload;
        state.loading = "loaded";
      }
    );
    builder.addCase(
      fetchOrderProductsPurchaseOrders.rejected,
      (state, action) => {
        state.loading = "error";
        state.error = action.error.message;
      }
    );
    builder.addCase(fetchPurchaseOrderByID.pending, (state) => {
      state.purchaseOrder = {};
      state.loading = "loading";
    });
    builder.addCase(fetchPurchaseOrderByID.fulfilled, (state, { payload }) => {
      state.purchaseOrder = payload;
      state.purchaseOrdersList = [payload];
      state.loading = "loaded";
    });
    builder.addCase(fetchPurchaseOrderByID.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
  },
});

export const {
  setPurchaseOrder,
  setViewing,
  setLastQuery,
  setPurchaseOrdersAmount,
  resetOrderProducts
} = purchaseOrdersSlice.actions;

export const selectPurchaseOrders = createSelector(
  (state) => ({
    purchaseOrders: state.purchaseOrders,
    purchaseOrder: state.purchaseOrders.purchaseOrder,
    purchaseOrdersList: state.purchaseOrders.purchaseOrdersList,
    orderProductsList: state.purchaseOrders.orderProductsList,
    loading: state.purchaseOrders.loading,
    message: state.purchaseOrders.message,
    error: state.purchaseOrders.error,
    viewing: state.purchaseOrders.viewing,
    purchaseOrdersAmount: state.purchaseOrders.purchaseOrdersAmount,
    lastQuery: state.purchaseOrders.lastQuery,
  }),
  (state) => state
);
export default purchaseOrdersSlice.reducer;
